interface AnimatedHeroTreeProps {
  src: string;
  alt: string;
}

/**
 * Hero tree with a continuous golden glow pulse.
 * Pure CSS animation (globals.css), GPU-accelerated, respects prefers-reduced-motion.
 */
export function AnimatedHeroTree({ src, alt }: AnimatedHeroTreeProps) {
  return (
    <>
      <div className="hidden lg:flex justify-center items-center">
        <img
          src={src}
          alt={alt}
          className="hero-tree w-full max-w-[720px] h-auto object-contain scale-140"
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
      </div>

      <img
        src={src}
        alt=""
        aria-hidden="true"
        className="hero-tree-mobile lg:hidden mx-auto w-[85%] max-w-sm h-auto object-contain -mt-12 sm:-mt-14 -mb-12 sm:-mb-16"
        loading="eager"
        decoding="async"
      />
    </>
  );
}
